<template>
  <div class="search-and-filters">
    <div class="search-box">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="search-icon">
        <circle cx="11" cy="11" r="8"/>
        <path d="M21 21l-4.35-4.35"/>
      </svg>
      <input 
        type="text" 
        v-model="searchQuery" 
        placeholder="Search courses..."
        class="search-input"
        @input="emitSearch"
      >
    </div>
    <div class="filter-controls">
      <select v-model="filters.status" class="filter-select" @change="emitFilters">
        <option value="">Status: All</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
        <option value="draft">Draft</option>
      </select>
      <select v-model="filters.category" class="filter-select" @change="emitFilters">
        <option value="">Category: All</option>
        <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.title }}</option>
      </select>
      <select v-model="filters.instructor" class="filter-select" @change="emitFilters">
        <option value="">Instructor: All</option>
        <option v-for="instructor in instructors" :key="instructor.user_id" :value="instructor.user_id">
          {{ instructor.first_name }} {{ instructor.last_name }}
        </option>
      </select>
      <select v-model="filters.type" class="filter-select" @change="emitFilters">
        <option value="">Type: All</option>
        <option value="premium">Premium</option>
        <option value="free">Free</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterControls',
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    instructors: {
      type: Array,
      default: () => []
    },
    initialFilters: {
      type: Object,
      default: () => ({
        status: '',
        category: '',
        instructor: '',
        type: ''
      })
    },
    initialSearch: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchQuery: this.initialSearch,
      filters: { ...this.initialFilters }
    };
  },
  methods: {
    emitFilters() {
      this.$emit('filter-change', { ...this.filters });
    },
    emitSearch() {
      this.$emit('search-change', this.searchQuery);
    }
  },
  watch: {
    initialFilters: {
      handler(newValue) {
        this.filters = { ...newValue };
      },
      deep: true
    },
    initialSearch(newValue) {
      this.searchQuery = newValue;
    }
  }
};
</script>

<style scoped>
.search-and-filters {
  background: white;
  border-radius: 16px;
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  gap: 1.5rem;
  align-items: center;
  flex-wrap: wrap;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1);
}

.search-box {
  position: relative;
  flex: 1;
  min-width: 250px;
}

.search-icon {
  position: absolute;
  left: 1.25rem;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  color: #6366F1;
}

.search-input {
  width: 100%;
  padding: 0.875rem 1rem 0.875rem 3rem;
  border: 2px solid #E2E8F0;
  border-radius: 12px;
  font-size: 0.875rem;
  color: #1E293B;
  background-color: #F8FAFC;
  transition: all 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: #6366F1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
  background-color: white;
}

.filter-controls {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.filter-select {
  padding: 0.875rem 2.5rem 0.875rem 1.25rem;
  border: 2px solid #E2E8F0;
  border-radius: 12px;
  font-size: 0.875rem;
  color: #1E293B;
  background-color: #F8FAFC;
  cursor: pointer;
  min-width: 160px;
  transition: all 0.2s;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236366F1' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1rem;
  appearance: none;
  font-weight: 500;
}

.filter-select:focus {
  outline: none;
  border-color: #6366F1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
  background-color: white;
}

@media (max-width: 1024px) {
  .search-and-filters {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }
  
  .search-box {
    width: 100%;
  }
  
  .filter-controls {
    width: 100%;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.75rem;
  }
  
  .filter-select {
    flex: 1;
    min-width: 0;
    max-width: calc(50% - 0.5rem);
  }
}

@media (max-width: 640px) {
  .search-and-filters {
    margin: 0 -1rem 1rem;
    width: calc(100% + 2rem);
    border-radius: 0;
    padding: 1rem;
  }
  
  .filter-select {
    max-width: 100%;
    width: 100%;
  }
}
</style> 